export type ModulosFornecedorModel = {
    aplicativo: boolean
    fidelidade: boolean
    delivery: boolean
    entregadores: boolean
    pedidosMesa: boolean
    centralPedidos: boolean
}

export const ModulosFornecedorInicial: ModulosFornecedorModel = {
    aplicativo: false,
    fidelidade: false,
    delivery: false,
    entregadores: false,
    pedidosMesa: false,
    centralPedidos: false,
}
